import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = () => ({
  csatSurvey: {}, 
});


export default { state, getters, actions, mutations };
